import { createContext, FC, useContext, useEffect, useState } from "react";

type ThemeContextT = {
  theme: string;
  switchTheme: (theme?: string) => void;
};

const ThemeContext = createContext<ThemeContextT>({
  theme: "system",
  switchTheme: () => {},
});

const switchSystemTheme = (theme: string, isWindowDark: boolean) => {
  document.body.className = "";
  if (theme === "system") {
    localStorage.removeItem("theme");
    if (isWindowDark) document.body.classList.add("dark");
  } else {
    document.body.classList.add(theme);
    localStorage.theme = theme;
  }
};

export const ThemeProvider: FC<React.PropsWithChildren> = ({ children }) => {
  const [theme, setTheme] = useState(localStorage.theme ?? "system");
  const isWindowDark = window.matchMedia(
    "(prefers-color-scheme: dark)",
  ).matches;

  const newMobileTheme = (theme: string) => {
    const isThemeDark =
      theme === "dark" || (theme === "system" && isWindowDark);
    return isThemeDark ? "light" : "dark";
  };

  const switchTheme = (newTheme?: string) => {
    if (!newTheme) newTheme = newMobileTheme(theme);
    setTheme(newTheme);
  };

  useEffect(() => {
    switchSystemTheme(theme, isWindowDark);
  }, [theme, isWindowDark]);

  return (
    <ThemeContext.Provider value={{ theme, switchTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  return useContext(ThemeContext);
};
